import { render, staticRenderFns } from "./MegaMenuCard.vue?vue&type=template&id=40bc2cf0&scoped=true&"
import script from "./MegaMenuCard.vue?vue&type=script&lang=ts&"
export * from "./MegaMenuCard.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenuCard.vue?vue&type=style&index=0&id=40bc2cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc2cf0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default})
